import { Slot, component$ } from "@builder.io/qwik";
import { Link, useLocation, type LinkProps } from "@builder.io/qwik-city";

export type NavLinkProps = LinkProps & {
  activeClass?: string;
  staticLink?: boolean;
};

export const NavLink = component$(
  ({ activeClass, staticLink, ...props }: NavLinkProps) => {
    const location = useLocation();
    const toPathname = props.href ?? "";
    const locationPathname = location.url.pathname;

    const isActive = (() => {
      if (toPathname === "/") {
        return locationPathname === "/";
      }
      const normalizedTo = toPathname.endsWith("/")
        ? toPathname.slice(0, -1)
        : toPathname;
      const normalizedLocation = locationPathname.endsWith("/")
        ? locationPathname.slice(0, -1)
        : locationPathname;
      return (
        normalizedLocation === normalizedTo ||
        normalizedLocation.startsWith(normalizedTo + "/")
      );
    })();

    if (staticLink) {
      return (
        <a
          {...props}
          class={`${props.class || ""} ${isActive ? activeClass : ""}`}
          data-state={isActive ? "selected" : ""}
        >
          <Slot />
        </a>
      );
    }

    return (
      <Link
        {...props}
        class={`${props.class || ""} ${isActive ? activeClass : ""}`}
        data-state={isActive ? "selected" : ""}
      >
        <Slot />
      </Link>
    );
  },
);
